<template>
  <v-dialog v-model="inputVal" width="700">
    <v-card class="rounded-lg">
      <v-card-title class="black_lighten3">
        <p-text variant="headingMd" as="h3" class="black--text">
          {{ $t('Account.smsAddon.confirmTitle') }}
        </p-text>
      </v-card-title>
      <v-divider />
      <div>
        <p-text variant="bodyMd" as="p" class="my-4 mx-6">
          {{ $t('Account.smsAddon.confirmText') }}
        </p-text>
        <v-divider />
        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-end align-center mx-2">
              <p-btn
                class="my-2 mr-6"
                :loading="link === ''"
                :disabled="link === ''"
                @click="redirect(link)"
                variant="primary"
              >
                {{ $t('Account.smsAddon.confirmChanges') }}
              </p-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import PBtn from '@/components/polaris/PBtn';
import PText from '@/components/polaris/PText';
export default {
  name: 'ConfirmPaymentDialog',
  components: {
    PBtn,
    PText,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    redirect(url) {
      window.top.location = url;
    },
  },
};
</script>
<style lang=""></style>
